import { Circle } from '@mui/icons-material';
import { Box, Paper } from '@mui/material';
import { ScatterPlotDatum, ScatterPlotTooltipProps } from '@nivo/scatterplot';
import { useTranslation } from 'react-i18next';

import { useSxStyles } from '~/scenes/PortalModules/Analytics/Rewarding/CompensationEqualityReport/CompensationEqualityCharts/CompensationScatterPlotTooltip/useStyles';
import { mergeSxProps } from '~/utils/helpers/sxProps';

type AxisValueProps = { label: string; value?: string | number };

const ScatterValue = (valueProps: AxisValueProps) => {
  const { label, value } = valueProps;

  const sxStyles = useSxStyles();

  return (
    <Box sx={sxStyles.pointData}>
      <Box sx={sxStyles.pointDataLabel}>{`${label}:`}</Box>
      <Box sx={sxStyles.pointDataValue}>{value}</Box>
    </Box>
  );
};

type PropsType = ScatterPlotTooltipProps<ScatterPlotDatum> & {
  axisProps: {
    getYProps: (value?: string | number) => AxisValueProps;
    getXProps: (value?: string | number) => AxisValueProps;
  };
};

export const CompensationScatterPlotTooltip = (props: PropsType) => {
  const {
    node,
    axisProps: { getYProps, getXProps },
  } = props;

  const { t } = useTranslation();

  const sxStyles = useSxStyles();

  return (
    <Paper sx={sxStyles.paper}>
      <Box sx={sxStyles.title}>
        <Circle
          sx={mergeSxProps(sxStyles.pointColor, {
            color: node.color,
          })}
        />
        <ScatterValue label={t('laGender')} value={node.serieId} />
      </Box>

      <Box sx={sxStyles.secondaryData}>
        <ScatterValue {...getYProps(node.formattedY)} />
        <ScatterValue {...getXProps(node.formattedX)} />
      </Box>
    </Paper>
  );
};
